import { useCallback } from 'react'
import { NumberFmt } from 'src/utils'
import { formatDateUTC } from 'src/utils/formatDate'
import { AdjustmentDetailItem } from '../../StockAdjustmentInBatchTypes'
import * as S from './PendingAdjustmentDetailsTable.styles'
import TableMui from 'src/components/TableMui'

interface Props {
  data: AdjustmentDetailItem[]
}

export default ({ data }: Props) => {
  const prepareData = useCallback((items: AdjustmentDetailItem[]) => items
    .map((item) => ({
      ...item,
      quantity: NumberFmt({ value: item.quantity, sufix: item.measureUnit }),
      validatedDate: formatDateUTC(item.validatedDate as Date, 'DD/MM/YYYY'),
    })), [])

  return (
    <S.Wrapper>
      <TableMui
        columns={[
          { id: 'productCode', label: 'Código do Produto' },
          { id: 'description', label: 'Descrição' },
          { id: 'address', label: 'Endereço' },
          { id: 'quantity', label: 'Qtd.' },
          { id: 'validatedDate', label: 'Data de validade' },
          { id: 'type', label: 'Tipo' },
          { id: 'reason', label: 'Justificativa' },
          { id: 'destination', label: 'Destino' },
        ]}
        emptyLabel='Nenhum produto encontrado.'
        rows={prepareData(data)}
        enablePagination
      />
    </S.Wrapper>

  )
}
